/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import useZohoPlanAddonsList from "../../hooks/useZohoPlanAddonsList";
import { useAccount } from "../../component/context/AccountProvider";
import { getAllPlansList } from "../../service/ZohoPlanService";
import { getMyDetails } from "../../service/myDeatils";

const PlanTypeConst = [
  { title: "Indvidual", value: "individual" },
  { title: "Firm", value: "law_firm" },
  { title: "Enterprise", value: "enterprise" },
];

const SectionTypeConst = [
  // { title: "All", value: "all" },
  { title: "India Law Online", value: "ILO" },
  // { title: "CaseBase", value: "litigation_solution" },
  // { title: "LawBase", value: "compliance_solution" },
  // { title: "OpsBase", value: "practice_management" },
];
const PlanList = ({ setSelectedPlans }) => {
  const [planList, setPlanList] = useState([]);
  // const { userDetails } = useAccount() || {};
  const [planTenure, setPlanTenure] = useState("month");
  // const [addons, setAddons] = useState({});
  const [userDetails, setUserDetails] = useState({})
  const { addonsList: addons } = useZohoPlanAddonsList();
  // const [planType, setPlanType] = useState(PlanTypeConst[0]?.value);
  const [planType, setPlanType] = useState("");
  const [sectionType, setSectionType] = useState(SectionTypeConst[0]?.value);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadUser() {
      try {
        const resp = await getMyDetails();
        setUserDetails(resp);
      } catch (err) {
        console.error("Failed to load user details:", err);
      }
    }
    loadUser();
  }, []);


  useEffect(() => {
    if (userDetails?.organisation?.org_type) {
      setPlanType(userDetails.organisation.org_type);
    }
  }, [userDetails]);


  useEffect(() => {
    console.log("Plan Type", userDetails)

  }, [userDetails])

  useEffect(() => {
    // Only trigger API when planType is ready
    if (!planType) return;

    getList();
  }, [planTenure, planType, sectionType]);

  const getList = async () => {
    setLoading(true);
    const data = await getAllPlansList({
      tenure: "annual",
      user_type: planType,
      section: sectionType,
    });

    if (Array.isArray(data?.data)) {
      const filteredPlans = data.data
        .filter((item) => item?.is_published)
        .sort((a, b) => (a.order || 0) - (b.order || 0));

      setPlanList(filteredPlans);
    }
    setLoading(false);
  };

  console.log(addons, "addons");
  console.log(userDetails, "userDetails");

  console.log(planList, "newDtaaList");
  return (
    <>
      <div className="plan-container">
        {/* Plan Type Selection */}
        <div className="plan-type-group">
          {/* {userDetails?.user_type === 'organisation' && userDetails?.organisation?.org_type ?
            PlanTypeConst?.filter((_) => _.value === userDetails?.organisation?.org_type)?.map((item) => {
              return (
                <button className={`plan-type-btn ${planType === item?.value ? "active" : ""}`} onClick={() => setPlanType(item?.value)} >
                  {item?.title}
                </button>
              );
            })
            :

            userDetails?.user_type === 'individual' ?
              <button className={`plan-type-btn ${planType === 'individual' ? "active" : ""}`} onClick={() => setPlanType('individual')} >
                Indvidual
              </button>

              :

              PlanTypeConst?.map((item) => {
                return (
                  <button className={`plan-type-btn ${planType === item?.value ? "active" : ""}`} onClick={() => setPlanType(item?.value)} >
                    {item?.title}
                  </button>
                );
              })
          } */}
        </div>
        {/* Plan Tenure Toggle */}
        <div className="plan-tenure-toggle">
          <button
            className={`tenure-btn ${planTenure === "month" ? "active" : ""}`}
            onClick={() => setPlanTenure("month")}
          >
            Monthly
          </button>
          <button
            className={`tenure-btn ${planTenure === "annual" ? "active" : ""}`}
            onClick={() => setPlanTenure("annual")}
          >
            Annually
          </button>
        </div>
      </div>
      <div className="plan-section-tabs-container">
        <div className="plan-section-tabs-group-list">
          {SectionTypeConst.map((item) => {
            return (
              <button
                className={`plan-type-btn ${sectionType === item?.value ? "active" : ""
                  }`}
                onClick={() => setSectionType(item?.value)}
              >
                {item?.title}
              </button>
            );
          })}
        </div>
      </div>


      {planList.length ?
        <div className="plan-grid">
          {planList.map((item, index) => (
            <div
              key={index}
              className="plan-card"
              onClick={() =>
                setSelectedPlans({
                  ...item,
                  addonsList: Array.isArray(addons[item?.plan_code])
                    ? addons[item?.plan_code]
                    : [],
                })
              }
            >
              {/* <h4 className="plan-title">{item?.name}</h4> */}
              <img
                className="plan-image"
                src={`data:image/${item?.plan_image_format};base64,${item?.plan_image}`}
                alt={item?.name}
              />
            </div>
          ))}
        </div>
        :
        <div className="plan-grid" style={{ gridTemplateColumns: 'unset', padding: '20px', textAlign: 'center', minHeight: '48vh' }}>
          <div className="" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <h4 className="plan-title">No plans found</h4>
          </div>
        </div>
      }
    </>
  );
};

export default PlanList;
